import { create } from 'zustand'

interface AlertItem {
  id: number
  message: string
}

interface AlertState {
  alerts: AlertItem[]
  push: (message: string) => void
  remove: (id: number) => void
}

let _id = 0
const nextId = () => {
  _id += 1
  return _id
}

// 전역 알림 큐 — axios interceptor 등 모듈 외부에서도 호출 가능
// useAlertStore.getState().push(message) 사용
export const useAlertStore = create<AlertState>(set => ({
  alerts: [],
  push: message => set(state => ({ alerts: [...state.alerts, { id: nextId(), message }] })),
  remove: id => set(state => ({ alerts: state.alerts.filter(a => a.id !== id) })),
}))
